export const state = () => ({
  showLocation: process.env.SYSTEM == 'app',
  deviceType: null,
  deviceFingerprint: null,
  locationAllowed: true,
  cashoutEnabled: true,
  cashoutHistory: [],
  iframePage: '', //track last iframe
  tab: null,
  iframeActive: false,
  appState: true,
  appReady: false,
  operatingSystem: null,
  leftSidebarOpen: false,
  rightSidebarOpen: false,
  localAuthAt: null,
  homeSection: 'highlights',
  platform: 'web',
  authRedirectTo: null,
  currency: process.env.DEFAULT_CURRENCY,
  homeTab: null,
  statId: null,
  inplay: null,
  inplayTab: null,
  freebetCount: null,
  globals: {},
  banners: [],
  bannersLoaded: false,
  selections: [],
  sports: [],
  country: null,
  betslipType: null,
  outrightMarketId: null,
  notifications:[],
  sportradarActive: null,
  betAssistId: null,
  openedModals: []
})

export const mutations = {
  addModal(state, value) {
    state.openedModals.push(value);
  },
  removeModal(state, value) {
    state.openedModals = state.openedModals.filter(item => item !== value)
  },
  setBetAssistId(state, value) {
    state.betAssistId = value;
  },
  setNotifications(state,notifications){
    state.notifications = notifications;
  },
  setDeviceType(state, deviceType) {
    state.deviceType = deviceType;
  },
  setDeviceFingerprint(state, deviceFingerprint) {
    state.deviceFingerprint = deviceFingerprint;
  },
  setLocationAllowed(state, locationAllowed) {
    state.locationAllowed = locationAllowed;
  }, 
  setIframePage(state, iframePage) {
    state.iframePage = iframePage;
  },
  setOutrightMarketId(state, outrightMarketId) {
    state.outrightMarketId = outrightMarketId;
  },
  setCashoutHistory(state, bets) {
    state.cashoutHistory = bets;
  },  
  addCashoutHistory(state, bet_id) {
    state.cashoutHistory.push(bet_id)
  },
  setLocationStatus(state, status) {
    state.showLocation = status
  },
  setCashoutStatus(state, status) {
    state.cashoutEnabled = status
  },
  setBetSlipType(state, type) {
    state.betslipType = type
  },
  setAppState(state, active) {
    state.appState = active
  },
  setLocalAuthAt(state, date) {
    state.localAuthAt = date
  }, 
  setFreebetCount(state, freebetCount) {
    state.freebetCount = freebetCount
  },
  setInplayTab(state, sport) {
    state.inplayTab = sport
  },
  setInplayEvent(state, inplay) {
    state.inplay = inplay
  },  
  setHeaderTab(state, tab) {
    state.tab = tab
  },
  setAppReady(state, appReady) {
    state.appReady = appReady
  },
  setIframeStatus(state, iframeActive) {
    state.iframeActive = iframeActive
  },   
  setOperatingSystem(state, os) {
    state.operatingSystem = os
  },     
  setPlatform(state, platform) {
    state.platform = platform
  },   
  setGlobals(state, globals) {
    state.globals = globals
  },
  setBanners(state, banners) {
    state.banners = banners
    state.bannersLoaded = true
  },    
  setHomeSection(state, home) {
    state.homeSection = home
  },  
  setHomeTab(state, home) {
    state.homeTab = home
  },
  setStatId(state, id) {
    state.statId = id
  },
  setAuthRedirectTo(state, path) {
    state.authRedirectTo = path
  },
  openLeftSidebar(state, visibility) {
    state.leftSidebarOpen = visibility
  },
  openRightSidebar(state, visibility) {
    state.rightSidebarOpen = visibility
  },
  setSports(state, sports) {
    state.sports = sports
  },
  setSportradarActive(state, value) {
    state.sportradarActive = value;
  },
  setStreamingVisible(state, value) {
    state.isStreamingVisible = value;
  },
  setStreamingVideo(state, value) {
    state.streamingVideo = value;
  },
  add(state, item) {
    console.log(item);
    state.selections.push(item)
  },
  remove(state, item) {
    console.log('state.selections', state.selections);
    state.selections = _.reject(state.selections, function(selection) {
      return  _.get(selection, 'outcome.id') === _.get(item, 'outcome.id');
    });
  },
  clear(state) {
    state.selections = []
  }
}


export const actions = {
  nuxtClientInit({ commit, dispatch }, context) {
    //dispatch('auth/setTokens');
  }
};